scrollHintInstance = new ScrollHint('.js-scrollable', {
    // applyToParents: true,
    i18n: {
        scrollable: 'スクロール可能'
    }
});
